import React from 'react'
import { ModalBody as ReactStrapModalBody, ModalBodyProps as ReactStrapModalBodyProps } from 'reactstrap'

export const ModalBody = (props: ReactStrapModalBodyProps) => <ReactStrapModalBody {...props} />
